// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaderboard-table {
  min-width: 400px;
  border-collapse: collapse;
  border-spacing: 0;
  border-radius: 0 0 6px 6px;
  overflow: hidden;

  thead tr {
    background-color: var(--primary-background-color);
    color: var(--secondary-accent-text-color);
    font-size: 12px;
    font-weight: 800;
    height: 32px;
    border-bottom: 1px solid var(--secondary-border-color);
    border-top: 1px solid var(--secondary-border-color);
  }

  th {
    padding: 8px 4px;
  }

  tbody tr {
    height: 40px;
    border-bottom: 1px solid var(--secondary-border-color);
    border-top: 1px solid var(--secondary-border-color);
    text-align: center;
    font-size: 14px;
    font-weight: 600;
  }

  tbody tr:last-child {
    border-bottom: none;
  }
}

.header-team {
  text-align: left;
}

.leaderboard-table tbody tr:nth-of-type(2n) {
  background-color: var(--primary-background-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/leaderboard/leaderboard-table.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;;EAEhB;IACE,iDAAiD;IACjD,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,sDAAsD;IACtD,mDAAmD;EACrD;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,sDAAsD;IACtD,mDAAmD;IACnD,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;AACnD","sourcesContent":[".leaderboard-table {\n  min-width: 400px;\n  border-collapse: collapse;\n  border-spacing: 0;\n  border-radius: 0 0 6px 6px;\n  overflow: hidden;\n\n  thead tr {\n    background-color: var(--primary-background-color);\n    color: var(--secondary-accent-text-color);\n    font-size: 12px;\n    font-weight: 800;\n    height: 32px;\n    border-bottom: 1px solid var(--secondary-border-color);\n    border-top: 1px solid var(--secondary-border-color);\n  }\n\n  th {\n    padding: 8px 4px;\n  }\n\n  tbody tr {\n    height: 40px;\n    border-bottom: 1px solid var(--secondary-border-color);\n    border-top: 1px solid var(--secondary-border-color);\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n  }\n\n  tbody tr:last-child {\n    border-bottom: none;\n  }\n}\n\n.header-team {\n  text-align: left;\n}\n\n.leaderboard-table tbody tr:nth-of-type(2n) {\n  background-color: var(--primary-background-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
